

import './Assets/css/hz-ui-framework.css';
import './Assets/js/hz-ui-framework.js';

import 'bootstrap-icons/font/bootstrap-icons.css';

import React from 'react';
import ReactDOM from 'react-dom';

import MainView from './Components/MainView';

import reportWebVitals from './reportWebVitals';

ReactDOM.render(<MainView />,document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();